// IMPORT BASE-MODULE
import BaseModule from '@core/modules/base-module/base-module';

const articleHeader=new BaseModule();
articleHeader.name='article-header';
articleHeader.init();

